<template>
  <div class="bid-row">
    <div @click="forwardInfo" style="width: 100%;">
      <div class="bid-title">
          <span>{{ project.name }}</span>
      </div>
      <div style="display: flex;" v-if="(project.path || []).length > 0">
        <div class="bid-sub-title">
          <div
            v-for="(pi, index) in (project.path || [])"
            :key="project.id+pi"
            v-show="project.pathDisplay
              || (index === (project.path || []).length - 1)">
            |&nbsp;&nbsp;{{ pi }}
          </div>
        </div>
        <div style="width: 1.85rem; color: #D3D3D3; cursor: pointer;">
          <div @click.stop="project.pathDisplay=!project.pathDisplay">
            <f7-icon
              :material="project.pathDisplay?'arrow_drop_up':'arrow_drop_down'">
            </f7-icon>
          </div>
        </div>
      </div>
      <div class="bid-size-price">
        <div>
          规模：{{ project.projectSize | formatNumberVal }} {{ project.sizeUnitDesc }}
          &nbsp;|&nbsp;
          单价：{{ project.prePrice | formatNumberVal }} {{ project.priceUnitDesc }}
        </div>
        <div>{{ project.createTime | formatDateValue }}</div>
      </div>
      <div class="bid-features">
        <div>
          队伍类型：{{ project.receptCompanyTypeDesc }}
          &nbsp;|&nbsp;
          专业特长：{{ project.receptFeaturesDesc }}
        </div>
      </div>
      <div class="bid-features">
        <div>招标人：{{ project.dutyDepartmentName }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import currency from 'currency.js';
import { fromNow } from '@/util/dateUtils';

export default {
  props: ['project'],
  data() {
    return {
    };
  },
  filters: {
    formatDateValue: value => fromNow(value),
    formatNumberVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '--';
    },
  },
  methods: {
    forwardInfo() {
      this.$f7router.navigate(`/bid/info/${this.project.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .bid-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 0.5rem 0rem;
  }

  .bid-title {
    font-size: 1rem;
    padding: 0rem 0rem 0.5rem 0rem;
  }

  .bid-sub-title {
    font-size: 0.8rem;
  }

  .bid-size-price {
    font-size: 0.8rem;
    color: $theme-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0rem;
  }

  .bid-features {
    font-size: 0.8rem;
    color: $second-font-color;
    padding: 0.1rem 0rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/BidProject.vue